<script>
/**
 * Background pontilhado (estilo Figma/Canva) renderizado como SVG inline.
 * Usa <pattern> SVG nativo — sem URL nem data-uri.
 *
 * Posiciona-se com `position: absolute; inset: 0` por padrão, então o
 * container pai precisa ter `position: relative`. O conteúdo do grid
 * (cards arrastáveis) deve vir DEPOIS deste componente no DOM e ter
 * `position: relative; z-index: 1` pra ficar acima.
 */
export default {
  name: 'DotPatternBackground',
  props: {
    /** Cor dos pontos (hex ou nome CSS). */
    color: {
      type: String,
      default: '#D8D8D8',
    },
    /** Raio do ponto em px. */
    dotSize: {
      type: Number,
      default: 1,
    },
    /** Espaçamento entre centros de pontos (tile size) em px. */
    spacing: {
      type: Number,
      default: 20,
    },
    /** Opacidade global do SVG (0..1). */
    opacity: {
      type: Number,
      default: 0.5,
    },
  },
  computed: {
    patternId() {
      // ID único por instância — evita conflito quando há várias na mesma página.
      return `dot-pattern-${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    class="dot-pattern-background"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    :style="{ opacity }"
  >
    <defs>
      <pattern
        :id="patternId"
        :width="spacing"
        :height="spacing"
        patternUnits="userSpaceOnUse"
      >
        <circle :cx="dotSize" :cy="dotSize" :r="dotSize" :fill="color" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" :fill="`url(#${patternId})`" />
  </svg>
</template>

<style lang="sass" scoped>
.dot-pattern-background
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  pointer-events: none
  z-index: 0
</style>
